import { Container, type Texture } from 'pixi.js';
import { SkillSlot, type SkillSlotData } from './SkillSlot';

// One row of the player's skills, top-left of the content area. Fractions are
// relative to the content height so the row scales with the window.
const PADDING_X = 0.02;
const PADDING_Y = 0;
const ICON_SIZE = 0.12;
// horizontal distance between slot centers, in icon sizes
const STEP_FACTOR = 1.25;

export type SkillsTabOptions = {
  // Content area size given by GameWindow.
  width: number;
  height: number;
  skills: SkillSlotData[];
  labelBg: Texture;
  fontFamily?: string;
  textResolution: number;
};

export class SkillsTab extends Container {
  constructor(opts: SkillsTabOptions) {
    super();
    const { height: h, skills, labelBg, fontFamily, textResolution } = opts;
    const iconSize = ICON_SIZE * h;
    const step = iconSize * STEP_FACTOR;
    const x0 = PADDING_X * h + iconSize / 2;
    const y0 = PADDING_Y * h + iconSize / 2;

    skills.forEach((data, i) => {
      const slot = new SkillSlot({ data, labelBg, iconSize, fontFamily, textResolution });
      slot.position.set(x0 + i * step, y0);
      this.addChild(slot);
    });
  }
}
